import React, { useCallback, useMemo } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { Trans } from 'react-i18next'
import { sentenceStyle } from './InformationContainer.styles'
import { useTheme } from '@mui/material/styles'
import OnboardingHeader from '../../../components/OnboardingHeader/OnboardingHeader'
import { CheckoutSessionUserResponse } from '../../../../../api/onboarding/useFetchUserByCeckoutSessionId'

type InformationContainerProps = {
	isCheckoutFlow: boolean
	checkoutData?: CheckoutSessionUserResponse
	loggedIn?: boolean
	wrongUser?: boolean
}

export default function InformationContainer({
	isCheckoutFlow,
	checkoutData,
	loggedIn,
	wrongUser,
}: InformationContainerProps) {
	const { palette } = useTheme()
	console.log('information container wrongUser', wrongUser)
	const translationKeys = useMemo(() => {
		if (wrongUser) {
			return [
				`<b>Hmm...</b>, this is a bit unusual.`,
				`<b>Something didn't match up.</b> It looks like you're logged into someone else's account, or you may have used a different email to pay for your order.`,
				`<b>Fear not!</b> We will help you out. Please email us at info@prop.ai and we will get you sorted.`,
			]
		} else if ((loggedIn && checkoutData) || checkoutData?.user_id) {
			return [
				`<b>Welcome!</b> We've found your existing account.`,
				`<b>You're call quota is recharged.</b> You now have a total balance of <i>${checkoutData.remaining_monthly_calls}</i> calls.`,
				`<b>Carpe diem!</b> We're excited to have you as a customer!`,
			]
		} else if (isCheckoutFlow && checkoutData && !checkoutData.user_id) {
			return [
				// Welcome them by name and congratulate on their purchase
				`<b>Welcome ${checkoutData.firstName || checkoutData.name.split(' ')[0]}</b>! You're going to love it here.`,
				// Highlight their subscription limits
				`<b>You have calls to spare!</b> You have a total balance of <i>${checkoutData.remaining_monthly_calls}</i> calls.`,
				// Call to action
				"<b>Let's get calling!</b> Complete your registration to get started.",
			]
		} else {
			return [
				'onboarding.register.firstSentence',
				'onboarding.register.secondSentence',
				'onboarding.register.thirdSentence',
			]
		}
	}, [isCheckoutFlow, checkoutData, loggedIn])

	const MarketingContent = useCallback(
		() =>
			translationKeys.map((key) => (
				<Box key={key}>
					<Typography sx={sentenceStyle}>
						<Trans i18nKey={key} components={{ b: <b style={{ color: palette.brand.main }} /> }} />
					</Typography>
				</Box>
			)),
		[translationKeys],
	)

	const getHeader = () => {
		if (wrongUser) {
			return (
				<Typography variant="h5" sx={{ fontWeight: 700 }}>
					Well, this is awkward...
				</Typography>
			)
		} else if (isCheckoutFlow && checkoutData) {
			return <OnboardingHeader i18nHeader={`Success!`} />
		} else {
			return <OnboardingHeader i18nHeader="onboarding.register.headerSentence" />
		}
	}

	return (
		<Stack gap="16px" width="100%" maxWidth="360px">
			<Box>
				<img
					src="/assets/images/onboarding/ringing_phone.svg"
					alt=""
					style={{ maxWidth: '100%', height: 'auto' }}
				/>
			</Box>
			<Box>{getHeader()}</Box>
			<MarketingContent />
		</Stack>
	)
}
